import React,{useEffect} from "react";
import { useParams } from "react-router";



import DemoScheduleIELTSNewLanding from "../../components/BookDemo/IELTSNewLanding/DemoScheduleIELTSNewLanding";
import SuccessMessageIELTSNewLanding from "../../components/BookDemo/IELTSNewLanding/SuccessMessageIELTSNewLanding";

import { initGA, initGA2, initGtm, initPixel } from "../../helpers/CampaignEvents";


const IELTSNewLanding = () => {
  const { component } = useParams();

  useEffect(() => {

    initPixel()
    initGA2()

  }, [])

  console.log(component)
  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">

          {component === "success" ? (
             <SuccessMessageIELTSNewLanding />
          ) :(
            <DemoScheduleIELTSNewLanding />

          )}
        </div>
      </div>
    </div>
  );
};

export default IELTSNewLanding;
